<div class="main-container" *ngIf="htmlString">
    <div class="confirmation-container">
        <div [innerHTML]="htmlString | safeHtml" >
        </div>
    </div>
</div>